module.exports = __webpack_public_path__ + "static/img/10.59278a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/10.png
// module id = uZx7
// module chunks = 0